import React, {Component} from "react";
import {connect} from "react-redux";
import {translate} from "react-i18nify";

import * as navigationActions from "../../../actions/navigationActions";
import * as componentTypes from "../../../constants/componentTypes";
import * as batchStatuses from "../../../constants/batchStatuses";
import * as modelHelper from "../../../helpers/modelHelper";

import Modal from "../generic/Modal";
import Table from "../generic/Table";

class InvalidBatchNumbersModal extends Component {
    handleCloseModalClick = () => {
        this.props.dispatchCloseWebViewModalAction();
    };

    getStatus = (statusId) => {
        switch (statusId) {
            case batchStatuses.BATCH_STATUS_WARNING:
                return (
                    <div className="color-error">
                        <span className="glyphicon glyphicon-exclamation-sign" />
                        &nbsp;
                        {translate("colorantBatchNumberSettings.possibleDamagedBatchOfColorant")}
                    </div>
                );
            case batchStatuses.BATCH_STATUS_INVALID:
                return (
                    <div className="color-error">
                        <span className="glyphicon glyphicon-remove-sign" />
                        &nbsp;
                        {translate("colorantBatchNumberSettings.defectiveBatchOfColorant")}
                    </div>
                );
            default:
                return translate("invalidBatchNumbersModal.unknownStatus");
        }
    };

    getTableRows = () => {
        return this.props.params.invalidBatches.map((batch) => {
            return modelHelper.buildTableRow([
                modelHelper.buildTableCell(
                    <React.Fragment>
                        <div
                            className="color-square vertical-center"
                            style={{
                                backgroundColor: batch.colorant.rgb,
                                maxHeight: "100%"
                            }}
                        />
                        {batch.colorant.name}
                    </React.Fragment>
                ),
                modelHelper.buildTableCell(batch.batchNumber),
                modelHelper.buildTableCell(this.getStatus(batch.statusId))
            ]);
        });
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <Table
                tableHeader={modelHelper.buildTableRow([
                    modelHelper.buildTableCell(translate("general.colorant")),
                    modelHelper.buildTableCell(translate("general.batchNumber")),
                    modelHelper.buildTableCell(translate("general.status"))
                ])}
                tableRows={this.getTableRows()}
                tableColumns={[
                    modelHelper.buildTableColumn("col-4 vertical-center"),
                    modelHelper.buildTableColumn("col-4 vertical-center"),
                    modelHelper.buildTableColumn("col-4 vertical-center")
                ]}
            />
        );
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(translate("invalidBatchNumbersModal.header"))}
                content={this.getContent()}
                footer={modelHelper.buildModalSection(
                    <div>
                        <span className="glyphicon glyphicon-info-sign" />
                        &nbsp;
                        {translate("invalidBatchNumbersModal.info")}
                    </div>
                )}
                styles={{
                    minWidth: "60%"
                }}
            />
        );
    }
}

const mapStoreToProps = () => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseWebViewModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.INVALID_BATCH_NUMBERS_MODAL));
        }
    };
};

export default InvalidBatchNumbersModal = connect(mapStoreToProps, mapDispatchToProps)(InvalidBatchNumbersModal);
